var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5625 2.15625C2.00437 2.15625 0.75 3.41062 0.75 4.96875V19.0312C0.75 20.5894 2.00437 21.8438 3.5625 21.8438H20.4375C21.9956 21.8438 23.25 20.5894 23.25 19.0312V4.96875C23.25 3.41062 21.9956 2.15625 20.4375 2.15625H3.5625ZM3.5625 4.96875H20.4375V19.0312H3.5625V4.96875ZM10.5938 7.78125V10.5938H7.78125V13.4062H10.5938V16.2188H13.4062V13.4062H16.2188V10.5938H13.4062V7.78125H10.5938Z",
    fill: "#7A6DB2",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllProduct);
export default __webpack_public_path__ + "static/media/allProduct.d134dd160b192bba68f388ace459c14e.svg";
export { ForwardRef as ReactComponent };